(() => {
  const monthMap = {
    "1": 0,
    "2": 1,
    "3": 2,
    "4": 3,
    "5": 4,
    "6": 5,
    "7": 6,
    "8": 7,
    "9": 8,
    "0": 9,
    O: 9,
    N: 10,
    D: 11
  };
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const seikoWindows = {
    "6105": [1968, 1977],
    "6119": [1967, 1979],
    "6139": [1969, 1979],
    "6309": [1976, 1988],
    "7002": [1988, 1996],
    "7S26": [1996, 2019],
    "7S36": [1996, 2019],
    "4R34": [2022, 9999],
    "4R35": [2010, 9999],
    "4R36": [2011, 9999],
    "6R15": [2006, 2019],
    "6R35": [2019, 9999],
    "6R54": [2023, 9999]
  };
  const citizenWindows = {
    "8110": [1972, 1979],
    F950: [2018, 9999],
    F990: [2018, 9999]
  };

  const normalize = (value) => value.trim().toUpperCase().replace(/\s+/g, "");

  const movementFrom = (value) => {
    const match = normalize(value).match(/[A-Z0-9]{4}/);
    return match ? match[0] : "";
  };

  const yearsForDigit = (digit, start, end) => {
    const years = [];
    for (let year = start; year <= end; year += 1) {
      if (String(year).endsWith(digit)) years.push(year);
    }
    return years;
  };

  const filterYears = (years, decade, window, currentYear) => years.filter((year) => {
    const inDecade = !decade || (year >= Number(decade) && year <= Number(decade) + 9);
    const inWindow = !window || (year >= window[0] && year <= Math.min(window[1], currentYear));
    return inDecade && inWindow;
  });

  const clearFieldError = (field, error) => {
    field.removeAttribute("aria-invalid");
    error.hidden = true;
    error.textContent = "";
  };

  const showFieldError = (field, error, message) => {
    field.setAttribute("aria-invalid", "true");
    error.textContent = message;
    error.hidden = false;
    field.focus();
  };

  const clearResult = (result) => {
    result.hidden = true;
    result.replaceChildren();
    result.removeAttribute("data-state");
  };

  const renderResult = (result, state, kicker, title, body, items) => {
    const kickerElement = document.createElement("p");
    kickerElement.className = "wb-tools__result-kicker";
    kickerElement.textContent = kicker;

    const titleElement = document.createElement("h3");
    titleElement.textContent = title;

    const bodyElement = document.createElement("p");
    bodyElement.textContent = body;

    result.replaceChildren(kickerElement, titleElement, bodyElement);

    if (items.length) {
      const list = document.createElement("ul");
      items.forEach((item) => {
        const listItem = document.createElement("li");
        listItem.textContent = item;
        list.append(listItem);
      });
      result.append(list);
    }

    result.dataset.state = state;
    result.hidden = false;
    result.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };

  document.querySelectorAll("[data-wb-seiko-tool]").forEach((root) => {
    const form = root.querySelector("form");
    const serialField = form.elements.serial;
    const calibreField = form.elements.calibre;
    const decadeField = form.elements.decade;
    const serialError = root.querySelector("[data-serial-error]");
    const result = root.querySelector("[data-result]");
    const currentYear = Number(root.dataset.currentYear);

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      clearFieldError(serialField, serialError);
      clearResult(result);

      const serial = normalize(serialField.value);
      const calibre = movementFrom(calibreField.value);
      const decade = decadeField.value;

      if (serial.includes("/")) {
        showFieldError(serialField, serialError, "That looks like a limited-edition number, not a production-date serial.");
        return;
      }

      if (!/^[0-9][1-9O0ND][0-9]{4}$/.test(serial)) {
        showFieldError(serialField, serialError, "Enter a traditional 6-character Seiko serial, such as 2D5822.");
        return;
      }

      const month = months[monthMap[serial[1]]];
      const productionWindow = calibre ? seikoWindows[calibre] : null;
      const candidates = filterYears(
        yearsForDigit(serial[0], 1966, currentYear),
        decade,
        productionWindow,
        currentYear
      );

      if (!candidates.length) {
        renderResult(
          result,
          "warning",
          "Details need checking",
          `${month}, year ending in ${serial[0]}`,
          "The serial pattern is readable, but the selected decade or calibre window does not line up. Recheck the caseback details.",
          [
            calibre ? `Calibre entered: ${calibre}` : "No recognised calibre window was used.",
            "The result is an estimate and does not verify authenticity."
          ]
        );
        return;
      }

      const exact = candidates.length === 1;
      renderResult(
        result,
        "success",
        exact ? "Strong collector estimate" : "Possible production dates",
        exact ? `${month} ${candidates[0]}` : `${month}, year ending in ${serial[0]}`,
        exact
          ? "The serial and the available calibre or decade context point to one production month."
          : `The serial repeats every decade. Possible years: ${candidates.join(", ")}.`,
        [
          `Serial sequence: ${serial.slice(2)}`,
          calibre
            ? productionWindow
              ? `Calibre ${calibre} was used to narrow the range.`
              : `Calibre ${calibre} is not yet in the supported range table.`
            : "Add the four-character calibre to narrow the decade.",
          "Production estimate only; not proof of authenticity."
        ]
      );
    });

    form.addEventListener("reset", () => {
      clearFieldError(serialField, serialError);
      clearResult(result);
      queueMicrotask(() => serialField.focus());
    });
  });

  document.querySelectorAll("[data-wb-citizen-tool]").forEach((root) => {
    const form = root.querySelector("form");
    const serialField = form.elements.serial;
    const modeField = form.elements.mode;
    const movementField = form.elements.movement;
    const decadeField = form.elements.decade;
    const serialError = root.querySelector("[data-serial-error]");
    const result = root.querySelector("[data-result]");
    const currentYear = Number(root.dataset.currentYear);

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      clearFieldError(serialField, serialError);
      clearResult(result);

      const serial = normalize(serialField.value);
      const mode = modeField.value;
      const movement = movementFrom(movementField.value);
      const decade = decadeField.value;

      if (mode === "unknown") {
        renderResult(
          result,
          "warning",
          "One detail is still needed",
          "Choose the serial era",
          "Citizen used different date formats. Confirm whether the watch is vintage, before 1980, or uses a modern 9-character serial.",
          [
            "Modern serials use 9 characters.",
            "The vintage guide applies only to watches produced before 1980.",
            "No number entered here is stored or sent."
          ]
        );
        return;
      }

      let month;
      let sequence;
      let candidates;

      if (mode === "modern") {
        if (!/^[0-9][1-9O0ND][0-9]{7}$/.test(serial)) {
          showFieldError(serialField, serialError, "Enter a modern 9-character Citizen serial, such as 8O1123456.");
          return;
        }
        month = months[monthMap[serial[1]]];
        sequence = serial.slice(2);
        candidates = yearsForDigit(serial[0], 1980, currentYear);
      } else {
        if (!/^[0-9]{8}$/.test(serial)) {
          showFieldError(serialField, serialError, "Enter an 8-digit vintage Citizen serial.");
          return;
        }
        const numericMonth = Number(serial.slice(1, 3));
        if (numericMonth < 1 || numericMonth > 12) {
          showFieldError(serialField, serialError, "The vintage month code must be between 01 and 12.");
          return;
        }
        month = months[numericMonth - 1];
        sequence = serial.slice(3);
        candidates = yearsForDigit(serial[0], 1930, 1979);
      }

      const productionWindow = movement ? citizenWindows[movement] : null;
      candidates = filterYears(candidates, decade, productionWindow, currentYear);

      if (!candidates.length) {
        renderResult(
          result,
          "warning",
          "Details need checking",
          `${month}, year ending in ${serial[0]}`,
          "The date pattern is readable, but the selected decade or movement range does not line up.",
          [
            movement ? `Movement entered: ${movement}` : "No recognised movement window was used.",
            "Recheck the caseback and choose the correct serial era.",
            "Production estimate only; not proof of authenticity."
          ]
        );
        return;
      }

      const exact = candidates.length === 1;
      renderResult(
        result,
        "success",
        exact ? "Estimated production date" : "Possible production dates",
        exact ? `${month} ${candidates[0]}` : `${month}, year ending in ${serial[0]}`,
        exact
          ? "The serial and the available movement or decade context point to one production month."
          : `The year digit repeats by decade. Possible years: ${candidates.join(", ")}.`,
        [
          `Serial sequence: ${sequence}`,
          movement
            ? productionWindow
              ? `Movement ${movement} was used to narrow the range.`
              : `Movement ${movement} is not yet in the supported range table.`
            : "Add the movement and approximate decade to narrow the result.",
          "Production estimate only; not proof of authenticity."
        ]
      );
    });

    form.addEventListener("reset", () => {
      clearFieldError(serialField, serialError);
      clearResult(result);
      queueMicrotask(() => serialField.focus());
    });
  });
})();
